// @flow
import React from "react";
import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import type { FieldProps } from "redux-form";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { MenuItem } from "@material-ui/core";
import type { Department } from "../../../core/entities/department.type";

type DepartmentFieldType = {
    region: string,
    departments: Array<Department>,
    inputComponent: Element,
    children: Element | Array<Element>,
} & FieldProps;

const RFDepartmentField = ({
    input,
    inputComponent,
    meta: { touched, error },
    region,
    departments,
}: DepartmentFieldType) => {
    let filteredDepartments = departments;

    if (region) {
        filteredDepartments = departments.filter(
            item => item.region === region
        );
    }
    return (
        <FormControl required fullWidth error={touched && error}>
            <Select
                input={inputComponent}
                {...input}
                onChange={event => input.onChange(event.target.value)}
                className="form__select"
                displayEmpty
            >
                <MenuItem value="" disabled>
                    Départements *
                </MenuItem>
                {filteredDepartments.map(department => (
                    <MenuItem key={department.id} value={department["@id"]}>
                        {department.name}
                    </MenuItem>
                ))}
            </Select>
            {touched && error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
};

const formSelector = formValueSelector("event");

const mapStateToProps = state => ({
    region: formSelector(state, "region"),
    departments: state.types.departments,
});

export default connect(mapStateToProps)(RFDepartmentField);
